import { Alert } from 'antd'

export default SequencedFormError = ({ error }) ->

  <Alert
    showIcon
    message="Error rendering form"
    description={error}
    type="error"
  />
